import { useEffect, useState } from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import Header from "./components/Header";
import Home from "./pages/Home";
import ThankYou from "./pages/thankyou";
import ThankYouTwo from "./pages/thankyoutwo";
import { buildVersion } from "./services/buildInfo";

function App() {
  const [customADL, setCustomADL] = useState({});

  useEffect(() => {
    // Initializing the Data Layer on the window object
    window.adobeDataLayer = window.adobeDataLayer || [];
    // Setting Page Level and user-specific variables
    window.adobeDataLayer.push({
      event: "pageView",
      web: {
        webPageDetails: {
          pageViews: {
            value: 1,
          },
          name: "icicibank:in:en:campaign:accounts:casa:savingsaccount:onboarding:landing page",

          URL: window.location.href,
          isErrorPage: "False",
        },
      },
      _icicibank: {
        channelInfo: {
          version: buildVersion,
          name: "nli",
        },
        pageInfo: {
          language: "en",
          country: "in",
          pageType: "campaign",
          virtualPageView: "no vpv",
          journey: "na",
          subJourney: "na",
          subSubJourney: "na",
        },
        userInfo: {
          userType: "na",
        },
        errorInfo: {
          errorType: "na",
          errorDetails: "na",
        },
      },
    });
  }, []);
  return (
    <>
      {/* update basename while pushing to UAT/LIVE {UAT: /casa/savingsAccount/main/, live:window.location.pathname } */}
      <Router basename={window.location.pathname}>
        <Header customADL={customADL} setCustomADL={setCustomADL} />
        <Routes>
          <Route
            exact
            path="/"
            element={<Home customADL={customADL} setCustomADL={setCustomADL} />}
          />
          <Route path="/thankyou" element={<ThankYou />} />
          <Route path="/thankyoutwo" element={<ThankYouTwo />} />
        </Routes>
      </Router>
    </>
  );
}

// https://campaigns.icicibank.com/casa/savingsAccount/main/index.html

export default App;
